"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var SaveButton_1 = __importDefault(require("./styledComponents/SaveButton"));
var ToggleButton_1 = __importDefault(require("./styledComponents/ToggleButton"));
var ListButton_1 = __importDefault(require("./styledComponents/ListButton"));
var Input_1 = __importDefault(require("./styledComponents/Input"));
var ClickLayer_1 = __importDefault(require("./styledComponents/ClickLayer"));
var ListWrapper_1 = __importDefault(require("./styledComponents/ListWrapper"));
var SavedSearchList_1 = __importDefault(require("../SavedSearchList/SavedSearchList"));
var SavedSearch_meta_1 = require("./SavedSearch.meta");
var mobx_1 = require("mobx");
var Translate_1 = require("../Translate/Translate");
var SavedSearch = /** @class */ (function (_super) {
    __extends(SavedSearch, _super);
    function SavedSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = SavedSearch_meta_1.SAVED_SEARCH_CATEGORY_KEY;
        _this.componentKey = SavedSearch_meta_1.SAVED_SEARCH_COMPONENT_KEY;
        _this.showInput = false;
        _this.showList = false;
        _this.showInput = !!props.showInput;
        return _this;
    }
    Object.defineProperty(SavedSearch.prototype, "saveButtonProps", {
        get: function () {
            var _this = this;
            var suppressAnalytics = this.props.suppressAnalytics;
            return {
                iconProps: {
                    asset: 'base.savedSearch.save',
                },
                onClick: function () {
                    _this.onSave();
                },
                suppressAnalytics: (suppressAnalytics == undefined) ? true : suppressAnalytics,
                disabled: this.props.saveButtonDisabled,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SavedSearch.prototype, "toggleButtonProps", {
        get: function () {
            var _this = this;
            var asset = this.showInput ? 'base.savedSearch.toggleClosed' : 'base.savedSearch.toggleOpen';
            var suppressAnalytics = this.props.suppressAnalytics;
            return {
                iconProps: {
                    asset: asset,
                },
                onClick: function () {
                    _this.toggleSave();
                },
                suppressAnalytics: (suppressAnalytics == undefined) ? true : suppressAnalytics,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SavedSearch.prototype, "listButtonProps", {
        get: function () {
            var _this = this;
            var suppressAnalytics = this.props.suppressAnalytics;
            return {
                iconProps: {
                    asset: 'base.savedSearch.list',
                },
                onClick: function () {
                    _this.toggleList();
                },
                suppressAnalytics: (suppressAnalytics == undefined) ? true : suppressAnalytics,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SavedSearch.prototype, "inputProps", {
        get: function () {
            var input = this.props.input;
            return input || {};
        },
        enumerable: true,
        configurable: true
    });
    SavedSearch.prototype.toggleSave = function (mustShowInput) {
        var onToggle = this.props.onToggle;
        if (typeof (mustShowInput) !== 'boolean') {
            mustShowInput = !this.showInput;
        }
        if (onToggle) {
            onToggle(mustShowInput);
        }
        this.showInput = mustShowInput;
    };
    SavedSearch.prototype.onSave = function () {
        var onSave = this.props.onSave;
        if (this.showInput && onSave) {
            onSave();
        }
    };
    SavedSearch.prototype.toggleList = function (mustShowList) {
        if (typeof (mustShowList) !== 'boolean') {
            mustShowList = !this.showList;
        }
        this.showList = mustShowList;
    };
    SavedSearch.prototype.componentDidUpdate = function (previousProps) {
        var showInput = this.props.showInput;
        if (showInput !== undefined && previousProps.showInput !== showInput) {
            this.showInput = showInput;
        }
    };
    SavedSearch.prototype.translateValue = function (translationContext, value) {
        return value ? translationContext.translate(value) : value;
    };
    SavedSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, savedSearchList = _a.savedSearchList;
        return (react_1.default.createElement(Wrapper_1.default, { className: className, key: this.showInput + "=" + this.showList },
            react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                var inputProps = _this.inputProps;
                if (inputProps) {
                    inputProps.placeholder = _this.translateValue(translationContext, inputProps.placeholder);
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    _this.showInput && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(Input_1.default, __assign({}, inputProps)),
                        react_1.default.createElement(SaveButton_1.default, __assign({}, _this.saveButtonProps)))),
                    react_1.default.createElement(ToggleButton_1.default, __assign({}, _this.toggleButtonProps)),
                    react_1.default.createElement(ListButton_1.default, __assign({}, _this.listButtonProps)),
                    _this.showList && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(ClickLayer_1.default, { onClick: function () {
                                _this.toggleList(false);
                            } }),
                        react_1.default.createElement(ListWrapper_1.default, null,
                            react_1.default.createElement(SavedSearchList_1.default, __assign({}, savedSearchList)))))));
            })));
    };
    __decorate([
        mobx_1.observable
    ], SavedSearch.prototype, "showInput", void 0);
    __decorate([
        mobx_1.observable
    ], SavedSearch.prototype, "showList", void 0);
    __decorate([
        mobx_1.computed
    ], SavedSearch.prototype, "saveButtonProps", null);
    __decorate([
        mobx_1.computed
    ], SavedSearch.prototype, "toggleButtonProps", null);
    __decorate([
        mobx_1.computed
    ], SavedSearch.prototype, "listButtonProps", null);
    __decorate([
        mobx_1.computed
    ], SavedSearch.prototype, "inputProps", null);
    __decorate([
        mobx_1.action
    ], SavedSearch.prototype, "toggleSave", null);
    __decorate([
        mobx_1.action
    ], SavedSearch.prototype, "onSave", null);
    __decorate([
        mobx_1.action
    ], SavedSearch.prototype, "toggleList", null);
    SavedSearch = __decorate([
        mobx_react_1.observer
    ], SavedSearch);
    return SavedSearch;
}(shared_1.ComponentBase));
exports.SavedSearch = SavedSearch;
exports.default = shared_1.InjectedStyledComponent(SavedSearch, SavedSearch_meta_1.SAVED_SEARCH_CATEGORY_KEY, SavedSearch_meta_1.SAVED_SEARCH_COMPONENT_KEY);
